var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"ml-2"},[_c('a',{attrs:{"href":'https://coach.getboarded.com/user/my-rater/rater-list?userId='+this.params.data.id+'&traineeName='+this.params.data.firstName+' '+this.params.data.lastName}},[_vm._v("Rater Details")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }